import { render, staticRenderFns } from "./video-info.vue?vue&type=template&id=755f448b&scoped=true&"
import script from "./video-info.vue?vue&type=script&lang=ts&"
export * from "./video-info.vue?vue&type=script&lang=ts&"
import style0 from "./video-info.vue?vue&type=style&index=0&id=755f448b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755f448b",
  null
  
)

export default component.exports